import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Comment } from '@mui/icons-material';
import CommentBottomSheet from '../components/CommentBottomSheet';

const TestCommentPage = () => {
  const [commentSheetOpen, setCommentSheetOpen] = useState(false);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Test Comment Registration
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        This page tests the comment registration flow. Click the button below to open the comment sheet.
      </Typography>
      
      <Button
        variant="contained"
        startIcon={<Comment />}
        onClick={() => setCommentSheetOpen(true)}
        sx={{ mb: 2 }}
      >
        Open Comment Sheet
      </Button>
      
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Expected behavior:
        <br />1. If not logged in, you should see "Register to Comment" button
        <br />2. Click it to see the registration form
        <br />3. Fill out the form to register as a commenter
        <br />4. After registration, you should be able to see and post comments
      </Typography>

      <CommentBottomSheet
        open={commentSheetOpen}
        onClose={() => setCommentSheetOpen(false)}
        blogPostId="test-blog-post-id"
        blogTitle="Test Blog Post"
      />
    </Box>
  );
};

export default TestCommentPage;
